"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signedOrdersSchema = {
    id: '/signedOrdersSchema',
    type: 'array',
    items: { $ref: '/SignedOrder' },
};
//# sourceMappingURL=signed_orders_schema.js.map